import React from "react";
import { useLang } from "../context/lang";
import { TriangleUpIcon, TriangleDownIcon } from "@primer/octicons-react";

export default ({ value }) => {
  const { t } = useLang();
  const [expanded, setExpanded] = React.useState(false);
  return (
    <div className="width-card-big bg-white shadow-sm rounded-lg px-20 py-18 mb-24">
      <h4 className="mb-24 w-100">{t("workExperience")}</h4>
      <div className="d-flex flex-wrap">
        {value
          .filter((_, i) => i <= (expanded ? value.length : 3))
          .map(({ key, value }, i) => (
            <div key={i} className="d-flex w-100 mb-16">
              <div className="w-30 text-gray-500 text-16">{key}</div>
              <div className="w-70 ml-16">{value}</div>
            </div>
          ))}
      </div>
      <h6
        className="text-right cursor-pointer hover-underline"
        onClick={() => setExpanded(prev => !prev)}
      >
        {" "}
        {value.length > 4 ? (
          expanded ? (
            <>
              <span>{t("less")}</span>
              <TriangleUpIcon />
            </>
          ) : (
            <>
              <span>{t("more")}</span>
              <TriangleDownIcon />
            </>
          )
        ) : null}
      </h6>
    </div>
  );
};
